import React from 'react';
import { Gauge, Eye, Cpu, Armchair, Trophy, GraduationCap } from 'lucide-react';

const RATING_META = [
  { key: 'rating_realism', label: 'Realism', icon: Gauge },
  { key: 'rating_immersion', label: 'Immersion', icon: Eye },
  { key: 'rating_hardware', label: 'Hardware Quality', icon: Cpu },
  { key: 'rating_comfort', label: 'Comfort', icon: Armchair },
  { key: 'rating_competitive', label: 'Competitive Racing', icon: Trophy },
  { key: 'rating_beginner_friendly', label: 'Beginner Friendly', icon: GraduationCap },
];

function RatingBar({ label, value, icon: Icon }) {
  const v = Number(value || 0);
  const pct = Math.min(100, (v / 10) * 100);
  return (
    <div className="bg-[#111115] border border-white/5 p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Icon className="w-4 h-4 text-primary" />
          <span className="text-white/70 text-xs font-bold tracking-wider uppercase">{label}</span>
        </div>
        <span className="text-white font-black text-lg">
          {v.toFixed(1)}<span className="text-white/30 text-xs font-normal">/10</span>
        </span>
      </div>
      <div className="h-1.5 bg-white/5 overflow-hidden">
        <div className="h-full bg-primary transition-all duration-700 ease-out" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export default function ShowcaseRatings({ rig }) {
  return (
    <section className="py-20 px-6 lg:px-10 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <p className="text-primary text-xs font-bold tracking-widest mb-3">PERFORMANCE RATINGS</p>
        <h2 className="text-white font-black text-3xl md:text-4xl uppercase mb-2">How It Scores</h2>
        <p className="text-white/40 text-sm mb-10 max-w-xl">
          Every rig benchmarked across six core disciplines. No compromises — just honest, measured performance.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {RATING_META.map((r) => (
            <RatingBar key={r.key} label={r.label} value={rig[r.key]} icon={r.icon} />
          ))}
        </div>
      </div>
    </section>
  );
}